import styled from 'styled-components'

export const StyledWrapper = styled.div`
  display: flex;
  justify-content: center;
`

export const StyledMobileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 232px;
  border-radius: 20px;
  border: 2.5px solid #dedede;
  padding-bottom: 10px;
`

export const StyledDivider = styled.span`
  background-color: #dedede;
  width: 38px;
  height: 4px;
  margin-top: 25px;
  border-radius: 3px;
`

export const StyledMobile = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 212px;
  margin-top: 25px;
  padding-bottom: 25px;
  background-color: #f9f9ff;
`

export const StyledHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0 5px 5px;
  background-color: #ee4360;
`

export const StyledHeaderTop = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const StyledTimeText = styled.span`
  font-size: 6px;
  color: #ffffff;
`

export const StyledIconsWrapper = styled.div`
  display: flex;
  gap: 5px;
`

export const StyledHeaderText = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: #ffffff;
`

export const StyledBodyTitle = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: #00112b;
  margin-top: 15px;
`

export const StyledBodyInfo = styled.span`
  font-size: 10px;
  font-weight: 700;
  color: #00112b;
  margin-top: 5px;
  padding: 0 10px;
`

export const StyledBodyText = styled.span`
  font-size: 10px;
  font-weight: 400;
  color: #00112b;
  overflow-wrap: anywhere;
  width: 100%;
  height: 225px;
  overflow-y: scroll;
  padding: 5px 10px;
  white-space: pre-wrap;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const StyledContinueButton = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 196px;
  height: 25px;
  margin-top: 20px;
  border-radius: 4px;
  background-color: #ee4360;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
`

export const StyledTouchPad = styled.span`
  width: 34px;
  height: 34px;
  margin-top: 8px;
  border-radius: 34px;
  border: 2.5px #dedede solid;
`
